import { get } from 'lodash';
import { Token } from './classes/Token';

export const rossumRpcMessageType = 'ROSSUM:RPC';

export type RPCMessage = {
  type: typeof rossumRpcMessageType;
  callId: string;
  methodCall: {
    methodName: string;
    params: unknown[];
  };
};

export const resolveResponse = async (
  postMessageClasses: PostMessageClasses,
  data: RPCMessage,
  createMessage: (response: unknown) => void,
  reportError: (response: unknown) => void
) => {
  const methodName = data?.methodCall?.methodName;
  const method = get(postMessageClasses, methodName);

  if (!method) {
    return reportError(`${methodName} is not supported.`);
  }

  try {
    const result = await method(...(data?.methodCall?.params || []));

    return createMessage(result);
  } catch (error) {
    return reportError(error);
  }
};

export type PostMessageClasses = {
  Token?: Token;
};
